import { render, staticRenderFns } from "./categoryDictionariesNewItem.vue?vue&type=template&id=75134de6&scoped=true&"
import script from "./categoryDictionariesNewItem.vue?vue&type=script&lang=js&"
export * from "./categoryDictionariesNewItem.vue?vue&type=script&lang=js&"
import style0 from "./categoryDictionariesNewItem.vue?vue&type=style&index=0&id=75134de6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75134de6",
  null
  
)

export default component.exports